import { NgModule } from '@angular/core';

import { DynamicComponentDirective } from './dynamicComponent.directive';

@NgModule({
  exports: [DynamicComponentDirective],
  declarations: [DynamicComponentDirective],
})
export class DynamicComponentModule {}
